import { combineReducers } from "redux";
import dashboard from "./dashboard";
import astrologerReducer from "./astrologerReducer";
import authReducer from "./authReducer";
import userReducer from "./userReducer";
import subAdminReducer from "./subAdminReducer";
import astromallReducer from "./astromallReducer";
import astropujaReducer from "./astropujaReducer";
import historyReducer from "./historyReducer";
import skillReducer from "./skillReducer";
import remediesReducer from "./remediesReducer";
import expertiseReducer from "./expertiseReducer";
import languageReducer from "./languageReducer";
import bannerReducer from "./bannerReducer";
import categoryReducer from "./categoryReducer";
import subCategoryReducer from './subCategoryReducer';
import yatraReducer from "./yatraReducer";
import sancharReducer from "./sancharReducer";
import religiousReducer from "./religiousReducer";
import ecommerceReducer from "./ecommerceReducer";

import testimonialsReducer from "./testimonialsReducer";
import transactionReducer from "./transactionReducer";
import operatorImageReducer from "./operatorImageReducer";
import flightImageReducer from "./flightImageReducer";
import staticPageReducer from "./staticPageReducer";
import roleReducer from "./roleReducer";
import issueReducer from "./issueReducer";

const rootReducer = combineReducers({
  dashboard,
  astrologerReducer,
  authReducer,
  userReducer,
  subAdminReducer,
  astromallReducer,
  astropujaReducer,
  historyReducer,
  skillReducer,
  remediesReducer,
  expertiseReducer,
  languageReducer,
  bannerReducer,
  categoryReducer,
  subCategoryReducer,
  yatraReducer,
  sancharReducer,
  religiousReducer,
  ecommerceReducer,

  testimonialsReducer,
  transactionReducer,
  operatorImageReducer,
  flightImageReducer,
  staticPageReducer,
  roleReducer,
  issueReducer
});

export default rootReducer;